var path = '/var/www/mmscny-website/src/app/common/components/social-share/social-share.html';
var html = "<div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 share-btn remove-padding\"> <p>Share on:</p> <div class=fb ng-if=$ctrl.showFacebookShareButton ng-click=$ctrl.openFb()> <img src=/./images/share_fb.png alt=\"share on facebook\"> </div> <div class=tw> <a href=\"https://twitter.com/share?url={{$ctrl.shareUrl}}\" target=_blank> <img src=/./images/share_tw.png alt=\"share on twitter\"> </a> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/social-share/social-share.html
// module id = 664
// module chunks = 0